if (!customElements.get('product-test')) {
  customElements.define('product-test', class ProductTest extends HTMLElement {
    constructor() {
      super();

      this.style.backgroundColor = 'red';
      jQuery(this).css({'background-color': 'blue'});
    }
  }
)};



